export const SHOW_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL =
  'SHOW_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL';
export const HIDE_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL =
  'HIDE_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL';

export const showShoppablePromotionConfirmationModal = (
  menuSlug,
  mealIds,
  basketWasInitiallySkipped
) => ({
  type: SHOW_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL,
  menuSlug,
  mealIds,
  basketWasInitiallySkipped,
});

export const hideShoppablePromotionConfirmationModal = () => ({
  type: HIDE_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL,
});
